import { AuthCompany } from 'components/auth'

export const isRSWWorkerAvailabilityEnabled = (
  company?: AuthCompany | null
) => {
  return Boolean(company)
}
